import React from 'react';
import { useSelector } from 'react-redux';

export default function ReadReceiptsModal({ open, onClose, readers }) {
    const allUsers = useSelector(s => s.user?.users || []);
    if (!open) return null;

    const map = (u) => {
        const id = u?._id || u;
        const found = allUsers.find(x => String(x._id) === String(id));
        const name = found ? `${found.firstName || ''} ${found.lastName || ''}`.trim() || found.email : id;
        const at = u?.seenAt || u?.readAt || null;
        return { id, name, at };
    };

    const items = (readers || []).map(map);

    return (
        <div className="modalChat-backdrop" onClick={onClose}>
            <div className="modalChat" onClick={e => e.stopPropagation()}>
                <div className="modalChat__header">
                    <h3>Кто прочитал</h3>
                    <button onClick={onClose}>✕</button>
                </div>
                <div className="modalChat__body">
                    <ul className="readers">
                        {items.length === 0 && <li className="empty">Пока никто</li>}
                        {items.map(r => (
                            <li key={r.id} className="readerRow">
                                <div className="readerAvatar">{(r.name || 'U').slice(0, 1)}</div>
                                <div className="readerMain">
                                    <div className="readerName">{r.name}</div>
                                    <div className="readerTime">{r.at ? new Date(r.at).toLocaleString() : ''}</div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
